import styled from '@emotion/styled'
import { TextItem } from '../../typography/TextItem/TextItem'
import { fonts } from '../../__styling/settings/fonts'
import { metrics } from '../../__styling/settings/metrics'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { breakWords } from '../../__styling/style-mixins'
import { themedValue } from '../../__styling/themed-value'

export const StyledParagraph = styled(TextItem)(({ theme }) => ({
    ...breakWords,
    margin: themedValue(theme, {
        thewest: `0 0 ${calcRem(metrics.thewest.textMargin / 2)} 0`,
        perthnow: `0 0 ${calcRem(metrics.perthnow.textMargin)} 0`,
        sevennews: `0 0 ${calcRem(metrics.sevennews.textMargin)} 0`,
    }),
    lineHeight: themedValue(theme, {
        thewest: 1.65,
        perthnow: 1.5,
        sevennews: 1.7,
    }),
    ...(theme.kind === 'sevennews' && {
        fontSize: calcRem(18),
        fontFamily: fonts.sevennews.headingAlternative,
        fontWeight: 300,
        strong: {
            fontWeight: 700,
        },
    }),
}))
